import { mixpanelApiHost } from "components/utils/network/endpoints";
import mixpanel from "mixpanel-browser";

export const initializeMixpanel = () => {
  const token = process.env.REACT_APP_MIXPANEL_TOKEN;
  const isDev = process.env.NODE_ENV === "development";
  if (token) {
    mixpanel.init(token, {
      debug: isDev,
      track_pageview: true,
      persistence: "cookie",
      api_host: mixpanelApiHost,
      record_sessions_percent: 100,
      cookie_domain: ".bizcrunch.co",
      cross_subdomain_cookie: true,
      secure_cookie: true,
      cross_site_cookie: true,
    });
  }
};
